export default __webpack_public_path__ + "static/media/Outfit-Medium.fea7d551.ttf";